var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowAlt216 = function SvgArrowAlt216(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-textGray, #6B6C83)",
    d: "M12.647 6 15 8.354l-2.354 2.353L11.94 10l1.147-1.146H1.293v-1h11.793l-1.147-1.147z"
  })));
};
export default SvgArrowAlt216;